module.exports = __webpack_public_path__ + "img/miniP.b6dcc2af.svg";